import { FormApi } from "final-form";
import { useEffect, useState } from "react";
import { Form } from "react-final-form";
import UiButton from "../../../components/button/Button";
import UiFormInfo from "../../../components/form-info/FormInfo.component";
import { List } from "../../../models/misc.model";
import { InputRadioFormData } from "../../../models/pages/showcases.model";
import { PageProps } from "../../../models/routing.model";
import { Validations } from "../../../services/form/validations.service";
import UiInputRadio from "../../../components/input-radio/InputRadio.component";

const InputRadioShowcase = (props: PageProps) => {
	const optionsList: List = [
		{ id: "1", label: "SHOWCASES.SELECT_SHOWCASE.OPTIONS_LIST.1" },
		{ id: "2", label: "SHOWCASES.SELECT_SHOWCASE.OPTIONS_LIST.2" },
		{ id: "3", label: "SHOWCASES.SELECT_SHOWCASE.OPTIONS_LIST.3", disabled: true },
		{ id: "4", label: "SHOWCASES.SELECT_SHOWCASE.OPTIONS_LIST.4" },
	];

	const [formData, setFormData] = useState<InputRadioFormData>({
		default: null,
		default_value: "1",
		disabled: null,
		disabled_value: "2",
		required: null,
	});

	useEffect(() => {
		console.log("Input radio: showcase > Form changed! ", formData);
	}, [formData]);

	const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

	// Submit
	const handleSubmit = async (
		data: InputRadioFormData,
		form: FormApi<InputRadioFormData, Partial<InputRadioFormData>>
	) => {
		console.log("Submitting... ", data, form, formData);
		await sleep(3000);
		// Update state onSubmit
		setFormData({ ...data });
	};

	return (
		<>
			<Form
				onSubmit={handleSubmit}
				initialValues={formData}
				render={({ handleSubmit, form, submitting }) => (
					<form onSubmit={handleSubmit}>
						<div className="row">
							<div className="col-12 col-sm-6 col-md-3 col-lg-3">
								<UiInputRadio
									id="default"
									label="SHOWCASES.COMMON_FIELDS.default"
									name="default"
									onChange={(e) => setFormData({ ...formData, default: e.value })}
									disabled={submitting}
									options={optionsList}
								/>
							</div>

							<div className="col-12 col-sm-6 col-md-3 col-lg-3">
								<UiInputRadio
									id="default_value"
									placeholder="SHOWCASES.COMMON_FIELDS.default_value"
									label="SHOWCASES.COMMON_FIELDS.default_value"
									name="default_value"
									onChange={(e) =>
										setFormData({ ...formData, default_value: e.value })
									}
									disabled={submitting}
									options={optionsList}
								/>
							</div>

							<div className="col-12 col-sm-6 col-md-3 col-lg-3">
								<UiInputRadio
									id="disabled"
									placeholder="SHOWCASES.COMMON_FIELDS.disabled"
									label="SHOWCASES.COMMON_FIELDS.disabled"
									name="disabled"
									onChange={(e) =>
										setFormData({ ...formData, disabled: e.value })
									}
									disabled={true}
									options={optionsList}
								/>
							</div>

							<div className="col-12 col-sm-6 col-md-3 col-lg-3">
								<UiInputRadio
									id="disabled_value"
									placeholder="SHOWCASES.COMMON_FIELDS.disabled_value"
									label="SHOWCASES.COMMON_FIELDS.disabled_value"
									name="disabled_value"
									onChange={(e) =>
										setFormData({ ...formData, disabled_value: e.value })
									}
									disabled={true}
									options={optionsList}
								/>
							</div>

							<div className="col-12 col-sm-6 col-md-3 col-lg-3">
								<UiInputRadio
									id="required"
									placeholder="SHOWCASES.COMMON_FIELDS.required"
									label="SHOWCASES.COMMON_FIELDS.required"
									name="required"
									onChange={(e) =>
										setFormData({ ...formData, required: e.value })
									}
									validations={[Validations.required]}
									disabled={submitting}
									options={optionsList}
								/>
							</div>
						</div>

						{/* SUBMIT */}
						<div className="text-end">
							<UiButton
								id="btnSubmit"
								type="submit"
								label={
									submitting
										? "SHOWCASES.COMMON_ACTIONS.BTN_SUBMITTING"
										: "SHOWCASES.COMMON_ACTIONS.BTN_SUBMIT"
								}
								disabled={submitting}
								loading={submitting}
							/>
						</div>

						{/* FORM INFORMATION */}
						<UiFormInfo {...(form as any)}></UiFormInfo>
					</form>
				)}
			/>
		</>
	);
};

export default InputRadioShowcase;
